var map = {
	"./adminStore.js": 6298,
	"./bankStore.js": 1354,
	"./collectionStore.js": 2473,
	"./customerStore.js": 2300,
	"./emailLogStore.js": 2092,
	"./faqStore.js": 1626,
	"./fileStore.js": 5208,
	"./modules.js": 2164,
	"./orderStore .js": 4943,
	"./pageStore.js": 5639,
	"./productStore.js": 238,
	"./schoolStore.js": 7633,
	"./shippingStore.js": 5934,
	"./sizeStore.js": 5962,
	"./snackbar.js": 1471,
	"./specStore.js": 208,
	"./supplierStore.js": 682,
	"./userStore.js": 7762,
	"./vendorStore.js": 4388
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6372;